import styled from '@emotion/styled';

import { css } from 'config/emotionCss';

export const Wrapper = styled.div`
  background-color: #FFFFFF;
  margin: 8px 0 0;
  padding: 28px;
  box-shadow: 0 0 12px 0 #0000001A;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 58px);

  .dropdown-language-title {
    margin: 0;
    padding: 0;
    font-size: 22px;
    font-weight: 500;
    vertical-align: middle;
  }

  .ant-dropdown-menu {
    padding: 0;
    margin: 0;
    box-shadow: none;
  }

  ul {
    margin: 12px;
    box-shadow: none;
  }
`;

export const OptionLanguageWrapper = styled.div`
  .sub-title-language {
    font-size: 12px;
  }

  &.language-selected .sub-title-language {
    opacity: 0.5;
  }
`;

export const languageDropdownLocaleWrapper = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
  overflow: hidden;
`;
